import { useEffect, useState } from 'react';
import shopifyAPI from '../../api/shopifyAPI.js';
import useDebouncedValue from '../../hooks/useDebouncedValue';

/**
 * Add-order product search with debounced API calls.
 */
export default function AddOrderProductSearch({ onAddVariant }) {
  const [productQuery, setProductQuery] = useState('');
  const [productResults, setProductResults] = useState([]);
  const [isSearchingProducts, setIsSearchingProducts] = useState(false);
  const debouncedQuery = useDebouncedValue(productQuery, 350);

  useEffect(() => {
    let cancelled = false;
    const q = (debouncedQuery || '').trim();
    if (!q || q.length < 2) {
      setProductResults([]);
      setIsSearchingProducts(false);
      return undefined;
    }

    const run = async () => {
      setIsSearchingProducts(true);
      try {
        const products = await shopifyAPI.getProducts(50);
        if (cancelled) return;
        const filtered = (products || []).filter((p) =>
          (p.title || '').toLowerCase().includes(q.toLowerCase()),
        );
        setProductResults(filtered.slice(0, 10));
      } catch (_) {
        if (!cancelled) setProductResults([]);
      } finally {
        if (!cancelled) setIsSearchingProducts(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [debouncedQuery]);

  return (
    <>
      <div className="form-group" style={{ gridColumn: '1 / -1' }}>
        <label>Search Product</label>
        <input
          type="text"
          placeholder="Type product name..."
          value={productQuery}
          onChange={(e) => setProductQuery(e.target.value)}
        />
      </div>
      {isSearchingProducts && (
        <div className="add-order-searching" style={{ gridColumn: '1 / -1', color: '#666' }}>
          Searching products...
        </div>
      )}
      {productResults.length > 0 && (
        <div className="add-order-search-results" style={{ gridColumn: '1 / -1' }}>
          {productResults.map((p) => (
            <div key={p.id} className="add-order-product-row">
              <div className="add-order-product-title">{p.title}</div>
              <div className="add-order-variant-wrap">
                {(p.variants || []).map((v) => (
                  <button
                    key={v.id}
                    type="button"
                    className="add-order-variant-btn"
                    onClick={() => {
                      onAddVariant(p, v);
                      setProductQuery('');
                      setProductResults([]);
                    }}
                  >
                    + {v.title || 'Default'} - ${v.price}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
